import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "market-type-tab-container" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "assets-info" }
const _hoisted_4 = { class: "assets-info-item-label" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "assets-info-item-value" }
const _hoisted_7 = { class: "market-type-tab-extra" }
const _hoisted_8 = { class: "icon-message-dialog-content" }
const _hoisted_9 = { class: "icon-message-dialog-content-title" }
const _hoisted_10 = { class: "icon-message-dialog-content-value" }

import { computed, PropType, ref } from 'vue'
import { useStore } from 'vuex'
import { HoldingsMutationTypes } from '@/store/modules/holdings/mutations-type'
import ghDialog from '@/components/common/Dialog.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'MarketTypeTab',
  props: {
  marketTypeList: {
    type: Array as PropType<{ label: string, value: string }[]>,
    default: () => []
  },
  assetsInfo: {
    type: Array as PropType<{ label: string, value: string, icon?: string }[]>,
    default: () => []
  },
  loadFunc: {
    type: Function as PropType<() => void>,
    default: () => {}
  }
},
  setup(__props) {

const store = useStore()

const showIconMessageDialog = ref(false)

const messaageDialogInfo = ref()

const props = __props

// 市场类型
const marketTypeActive = computed(() => store.state.holdings.marketTypeActive)

// 是否显示资产详情
const isShowAssetsDetail = computed(() => store.state.holdings.isShowAssetsDetail)

// 市场类型点击
const marketTypeClick = (item: { label: string, value: string }) => {
  store.commit(HoldingsMutationTypes.SET_MARKET_TYPE_ACTIVE, item)
  props.loadFunc()
}

const clickIcon = (item: { label: string, value: string, icon?: string }) => {
  if (item.icon === 'fetchBalanceDisplay') {
    messaageDialogInfo.value = {
      title: '免责声明',
      content: '「现金可提」仅供参考，该数据或未能反映账户的实时现金可提的金额，以及或未包含其他影响现金可提的收入和费用，如交易费用和处理费用等。阁下任何依赖或就该数据所作的任何决定，金马证券概不负责。若需查询实际「现金可提」，请电邮至cs@goldhorse.com.hk。'
    }
    showIconMessageDialog.value = true
  } else if (item.icon === 'enableBalanceDisplay') {
    messaageDialogInfo.value = {
      title: '免责声明',
      content: '「最大购买力」仅供参考，该数据或未能反映帐户的实时最大购买力，以及或未包含其他影响最大购买力的收入和费用等。阁下任何依赖或就该数据所作的任何决定，金马证券概不负责。若需查询实际「最大购买力」，请电邮至cs@goldhorse.com.hk。'
    }
    showIconMessageDialog.value = true
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(['market-type-tab-list', __props.marketTypeList.length > 0 ? 'line-bottom' : ''])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.marketTypeList, (item) => {
        return (_openBlock(), _createElementBlock("span", {
          class: _normalizeClass(['market-type-tab-item-label', item.value === marketTypeActive.value.value ? 'active' : '']),
          key: item.label,
          onClick: ($event: any) => (marketTypeClick(item))
        }, _toDisplayString(item.label), 11, _hoisted_2))
      }), 128))
    ], 2),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.assetsInfo, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "assets-info-item",
          key: item.label
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", null, _toDisplayString(item.label), 1),
            (item.icon)
              ? (_openBlock(), _createElementBlock("i", {
                  key: 0,
                  class: "assets-info-item-icon",
                  onClick: ($event: any) => (clickIcon(item))
                }, null, 8, _hoisted_5))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_6, _toDisplayString(isShowAssetsDetail.value ? item.value : '**** ****'), 1)
        ]))
      }), 128)),
      _createElementVNode("div", _hoisted_7, [
        _renderSlot(_ctx.$slots, "tab-extra")
      ])
    ]),
    _createVNode(ghDialog, {
      modelValue: showIconMessageDialog.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showIconMessageDialog).value = $event)),
      onConfirm: _cache[1] || (_cache[1] = ($event: any) => (showIconMessageDialog.value = false)),
      "confirm-text": "我知道了",
      "show-confirm": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, _toDisplayString(messaageDialogInfo.value.title), 1),
          _createElementVNode("div", _hoisted_10, _toDisplayString(messaageDialogInfo.value.content), 1)
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})